"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.all = all;
exports.list = list;
exports.batchUpdate = batchUpdate;
exports.get = get;
exports.batchGet = batchGet;
exports.fetchHistory = fetchHistory;
exports.inboxDnd = inboxDnd;
exports.markAll = markAll;
exports.markAllDeleted = markAllDeleted;
exports.endpoints = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _requests = require("@edison/requests");

var _functools = require("@edison/functools");

var _utils = require("./utils");

var _constants = require("../utils/constants");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var endpoints = {
  all: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/list_all_ids");
    }
  },
  list: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/thread/list");
    }
  },
  batchUpdate: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/thread_action");
    }
  },
  get: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/read_thread");
    }
  },
  batchGet: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/thread_batch_get");
    }
  },
  history: {
    method: 'GET',
    url: function url() {
      return "/".concat(_constants.API_V1, "/xhistory");
    }
  },
  inboxDnd: {
    method: 'PUT',
    url: function url() {
      return "/".concat(_constants.API_V1, "/inbox/dnd");
    }
  },
  markAll: {
    method: 'POST',
    url: function url() {
      return "/".concat(_constants.API_V1, "/mark_all");
    }
  },
  markAllDeleted: {
    method: 'DELETE',
    url: function url() {
      return "/".concat(_constants.API_V1, "/mark_all");
    }
  }
};
exports.endpoints = endpoints;

/**
 * Return complete messages metadata
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @returns {Promise<ThreadAllResponse>}
 * @throws {RequestError}
 */
function all(_x) {
  return _all.apply(this, arguments);
}

function _all() {
  _all = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(_ref) {
    var auth, optionals, _endpoints$all, method, url, res;

    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            auth = _ref.auth;
            optionals = (0, _utils.withAuth)(auth)(_utils.defaultOptionals);
            _endpoints$all = endpoints.all, method = _endpoints$all.method, url = _endpoints$all.url;
            _context.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context.sent;
            return _context.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: _objectSpread(_objectSpread({}, res.result), {}, {
                messages: (0, _utils.metadataFormatter)(res.result.messages)
              })
            }));

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return _all.apply(this, arguments);
}

/**
 * Return a list of mails by specified label and page
 *
 * @param {Auth} auth - User authentication info
 * @param {string} labelId - Unique label ID
 * @param {page?} page - Speficied page number
 * @returns {Promise<ThreadListResponse>}
 * @throws {RequestError}
 */
function list(_x2, _x3) {
  return _list.apply(this, arguments);
}

function _list() {
  _list = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2(_ref2, rest) {
    var auth, label, pageToken, accountLabel, offset, _ref2$size, size, _ref2$batchGet, batchGet, optionals, _endpoints$list, method, url, res, _res$result, ids, threads, next_page_token, latest_history_id, _res$result$estimate_, estimate_total, _res$result$estimate_2, estimate_unread;

    return _regenerator["default"].wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            auth = _ref2.auth, label = _ref2.label, pageToken = _ref2.pageToken, accountLabel = _ref2.accountLabel, offset = _ref2.offset, _ref2$size = _ref2.size, size = _ref2$size === void 0 ? 50 : _ref2$size, _ref2$batchGet = _ref2.batchGet, batchGet = _ref2$batchGet === void 0 ? false : _ref2$batchGet;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              label: label,
              pageToken: pageToken,
              accountLabel: accountLabel,
              size: size,
              offset: offset,
              batchGet: Number(batchGet)
            }), (0, _utils.withOptionals)(rest))(_utils.defaultOptionals);
            _endpoints$list = endpoints.list, method = _endpoints$list.method, url = _endpoints$list.url;
            _context2.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context2.sent;
            _res$result = res.result, ids = _res$result.ids, threads = _res$result.threads, next_page_token = _res$result.next_page_token, latest_history_id = _res$result.latest_history_id, _res$result$estimate_ = _res$result.estimate_total, estimate_total = _res$result$estimate_ === void 0 ? 0 : _res$result$estimate_, _res$result$estimate_2 = _res$result.estimate_unread, estimate_unread = _res$result$estimate_2 === void 0 ? 0 : _res$result$estimate_2;
            return _context2.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: {
                ids: ids,
                historyId: latest_history_id,
                estimateTotal: estimate_total,
                estimateUnread: estimate_unread,
                nextPageToken: next_page_token,
                threads: (batchGet && threads || []).map(function (thread) {
                  return _objectSpread(_objectSpread({}, thread), {}, {
                    messages: thread.messages.map(_utils.messageFormatter)
                  });
                })
              }
            }));

          case 8:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _list.apply(this, arguments);
}

/**
 * Thread related actions API call.
 * e.g: mark as read or unread, archive, add or remove label
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {Object} remove - Thread ids to delete
 * @param {Object[]} addLabel - Thread ids to move to specified labels
 * @param {Object[]} delLabel - Thread ids to remove from specified labels
 * @returns {Promise<ThreadBatchUpdateResponse>}
 */
function batchUpdate(_x4, _x5) {
  return _batchUpdate.apply(this, arguments);
}

function _batchUpdate() {
  _batchUpdate = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(_ref3, _ref4) {
    var remove, addLabel, delLabel, auth, optionals, _endpoints$batchUpdat, method, url, res;

    return _regenerator["default"].wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            remove = _ref3.remove, addLabel = _ref3.addLabel, delLabel = _ref3.delLabel;
            auth = _ref4.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              remove: remove,
              addLabel: addLabel,
              delLabel: delLabel
            }))(_utils.defaultOptionals);
            _endpoints$batchUpdat = endpoints.batchUpdate, method = _endpoints$batchUpdat.method, url = _endpoints$batchUpdat.url;
            _context3.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context3.sent;
            return _context3.abrupt("return", res);

          case 8:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _batchUpdate.apply(this, arguments);
}

/**
 * Return a list of mails by specified label and page
 *
 * @param {Auth} auth - User authentication info
 * @param {string} labelId - Unique label ID
 * @param {id} threadId - Speficied page number
 * @returns {Promise<ThreadListResponse>}
 * @throws {RequestError}
 */
function get(_x6) {
  return _get.apply(this, arguments);
}
/**
 * Returns a list of threads by specified ids
 *
 * @public
 * @param {Auth} auth - User validated authentication
 * @param {Array<string>} threadIds - IDs to fetch
 * @returns {Promise<APIResponse<$ReadOnlyArray<Thread>>>}
 */


function _get() {
  _get = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(_ref5) {
    var auth, label, id, optionals, _endpoints$get, method, url, res;

    return _regenerator["default"].wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            auth = _ref5.auth, label = _ref5.label, id = _ref5.id;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              label: label,
              id: id
            }))(_utils.defaultOptionals);
            _endpoints$get = endpoints.get, method = _endpoints$get.method, url = _endpoints$get.url;
            _context4.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context4.sent;
            return _context4.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: _objectSpread(_objectSpread({}, res.result), {}, {
                messages: res.result.messages.map(_utils.messageFormatter)
              })
            }));

          case 7:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _get.apply(this, arguments);
}

function batchGet(_x7, _x8) {
  return _batchGet.apply(this, arguments);
}

function _batchGet() {
  _batchGet = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5(threadIds, _ref6) {
    var auth, optionals, _endpoints$batchGet, method, url, res;

    return _regenerator["default"].wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            auth = _ref6.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              threadIds: threadIds
            }))(_utils.defaultOptionals);
            _endpoints$batchGet = endpoints.batchGet, method = _endpoints$batchGet.method, url = _endpoints$batchGet.url;
            _context5.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context5.sent;
            return _context5.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: (res.result || []).map(function (thread) {
                return _objectSpread(_objectSpread({}, thread), {}, {
                  messages: thread.messages.map(_utils.messageFormatter)
                });
              })
            }));

          case 7:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _batchGet.apply(this, arguments);
}

/**
 * Return a list of history based on thread
 *
 * @param {string} lastHistoryId - Latest history ID for label changed and messages deleted
 * @param {string} lastMessageHistoryId - Latest history ID for new messages
 * @param {Auth} auth - User valid authentication
 * @returns {Promise<HistoryResponse>}
 * @throws {RequestError}
 */
function fetchHistory(_x9) {
  return _fetchHistory.apply(this, arguments);
}

function _fetchHistory() {
  _fetchHistory = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6(_ref7) {
    var auth, lastHistoryId, lastMessageHistoryId, optionals, _endpoints$history, method, url, res, history;

    return _regenerator["default"].wrap(function _callee6$(_context6) {
      while (1) {
        switch (_context6.prev = _context6.next) {
          case 0:
            auth = _ref7.auth, lastHistoryId = _ref7.lastHistoryId, lastMessageHistoryId = _ref7.lastMessageHistoryId;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              lastHistoryId: lastHistoryId,
              lastMsgAddId: lastMessageHistoryId
            }))(_utils.defaultOptionals);
            _endpoints$history = endpoints.history, method = _endpoints$history.method, url = _endpoints$history.url;
            _context6.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context6.sent;
            history = res.result.history;
            return _context6.abrupt("return", _objectSpread(_objectSpread({}, res), {}, {
              result: _objectSpread(_objectSpread({}, res.result), {}, {
                history: (0, _utils.historyFormatter)(history)
              })
            }));

          case 8:
          case "end":
            return _context6.stop();
        }
      }
    }, _callee6);
  }));
  return _fetchHistory.apply(this, arguments);
}

function inboxDnd(_x10, _x11) {
  return _inboxDnd.apply(this, arguments);
}

function _inboxDnd() {
  _inboxDnd = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee7(_ref8, _ref9) {
    var source, target, addLabels, delLabels, senders, _ref8$applyAll, applyAll, auth, optionals, _endpoints$inboxDnd, method, url, res;

    return _regenerator["default"].wrap(function _callee7$(_context7) {
      while (1) {
        switch (_context7.prev = _context7.next) {
          case 0:
            source = _ref8.source, target = _ref8.target, addLabels = _ref8.addLabels, delLabels = _ref8.delLabels, senders = _ref8.senders, _ref8$applyAll = _ref8.applyAll, applyAll = _ref8$applyAll === void 0 ? false : _ref8$applyAll;
            auth = _ref9.auth;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withBody)({
              source: source,
              target: target,
              addLabels: addLabels,
              delLabels: delLabels,
              senders: senders
            }))(_utils.defaultOptionals);
            _endpoints$inboxDnd = endpoints.inboxDnd, method = _endpoints$inboxDnd.method, url = _endpoints$inboxDnd.url;
            _context7.next = 6;
            return (0, _requests.request)(url(), method, optionals);

          case 6:
            res = _context7.sent;
            return _context7.abrupt("return", res);

          case 8:
          case "end":
            return _context7.stop();
        }
      }
    }, _callee7);
  }));
  return _inboxDnd.apply(this, arguments);
}

/**
 * Update all the threads from specific label
 *
 * @public
 * @param {Auth} auth - User valid authentication
 * @param {string} label - Label where the threads're from
 * @param {string} accountLabel - Which account the threads're belong
 * @param {[]string} addLabel - Labels to add
 * @param {[]string} delLabel - Labels to remove
 * @returns {Promise<APIResponse<void>>}
 *
 */
function markAll(_x12) {
  return _markAll.apply(this, arguments);
}

function _markAll() {
  _markAll = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee8(_ref10) {
    var auth, label, accountLabel, addLabel, delLabel, optionals, _endpoints$markAll, method, url, res;

    return _regenerator["default"].wrap(function _callee8$(_context8) {
      while (1) {
        switch (_context8.prev = _context8.next) {
          case 0:
            auth = _ref10.auth, label = _ref10.label, accountLabel = _ref10.accountLabel, addLabel = _ref10.addLabel, delLabel = _ref10.delLabel;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              label: label,
              account_label: accountLabel
            }), (0, _requests.withBody)({
              addLabel: addLabel,
              delLabel: delLabel
            }))(_utils.defaultOptionals);
            _endpoints$markAll = endpoints.markAll, method = _endpoints$markAll.method, url = _endpoints$markAll.url;
            _context8.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context8.sent;
            return _context8.abrupt("return", res);

          case 7:
          case "end":
            return _context8.stop();
        }
      }
    }, _callee8);
  }));
  return _markAll.apply(this, arguments);
}

/**
 * Deletes all the messages in the specific label
 *
 * @public
 * @param {Auth} auth - User valid authentication
 * @param {string} label - Label where the threads locate
 * @param {string} accountLabel - The account the threads're belong
 */
function markAllDeleted(_x13) {
  return _markAllDeleted.apply(this, arguments);
}

function _markAllDeleted() {
  _markAllDeleted = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee9(_ref11) {
    var auth, label, accountLabel, optionals, _endpoints$markAllDel, method, url, res;

    return _regenerator["default"].wrap(function _callee9$(_context9) {
      while (1) {
        switch (_context9.prev = _context9.next) {
          case 0:
            auth = _ref11.auth, label = _ref11.label, accountLabel = _ref11.accountLabel;
            optionals = (0, _functools.compose)((0, _utils.withAuth)(auth), (0, _requests.withParams)({
              label: label,
              account_label: accountLabel
            }))(_utils.defaultOptionals);
            _endpoints$markAllDel = endpoints.markAllDeleted, method = _endpoints$markAllDel.method, url = _endpoints$markAllDel.url;
            _context9.next = 5;
            return (0, _requests.request)(url(), method, optionals);

          case 5:
            res = _context9.sent;
            return _context9.abrupt("return", res);

          case 7:
          case "end":
            return _context9.stop();
        }
      }
    }, _callee9);
  }));
  return _markAllDeleted.apply(this, arguments);
}
//# sourceMappingURL=threads.js.map